var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "g-pay") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g-pay",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.448,7.134 C13.448,6.661 13.408,6.204 13.332,5.768 L6.988,5.768 L6.988,8.356 L10.622,8.356 C10.4715144,9.1915874 9.98595174,9.92932467 9.278,10.398 L9.278,12.078 L11.447,12.078 C12.717,10.908 13.448,9.178 13.448,7.134",
    id: "Path",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.988,13.7 C8.804,13.7 10.332,13.105 11.447,12.079 L9.278,10.398 C8.675,10.804 7.898,11.041 6.988,11.041 C5.234,11.041 3.744,9.859 3.212,8.267 L0.978,8.267 L0.978,9.998 C2.12092398,12.2685859 4.44598592,13.701149 6.988,13.701",
    id: "Path",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.212,8.267 C2.93136956,7.43263132 2.93136956,6.52936868 3.212,5.695 L3.212,3.964 L0.978,3.964 C0.50573075,4.89917308 0.26011321,5.93234254 0.260997607,6.98 C0.260997607,8.065 0.521,9.09 0.978,9.997 L3.212,8.266 L3.212,8.267 Z",
    id: "Path",
    fill: "#FABB05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.988,2.921 C7.98,2.921 8.868,3.261 9.568,3.929 L9.568,3.93 L11.488,2.012 C10.324,0.928 8.804,0.26199994 6.989,0.26199994 C4.4472078,0.261660789 2.12220201,1.69380246 0.979,3.964 L3.213,5.695 C3.745,4.103 5.235,2.921 6.989,2.921",
    id: "Path",
    fill: "#E94235"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGoogle);
export default __webpack_public_path__ + "static/media/logo-google.96b332fc0a0531ad52eb6b05d9d0184d.svg";
export { ForwardRef as ReactComponent };